import { combineReducers } from 'redux';

import * as artists from './modules/artists';
import * as collections from './modules/collections';
import * as metadata from './modules/metadata';
import * as products from './modules/products';
import * as shopifyProducts from './modules/shopifyProducts';

const reducer = combineReducers({
  [artists.STATE_KEY]: artists.reducer,
  [collections.STATE_KEY]: collections.reducer,
  [products.STATE_KEY]: products.reducer,
  [shopifyProducts.STATE_KEY]: shopifyProducts.reducer,
  [metadata.STATE_KEY]: metadata.reducer
});

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducer.js